import { EditorState } from 'draft-js';
import React, { Component } from 'react';
import { GET_ALL_TECHS_NEW, AccountClient } from '@nile/graphql';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { injectIntl } from 'react-intl';
import { isAuthorised, AppContext } from '@nile/components';
import RTEditor from './RTEditor';

class EmailEditor extends Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      placeholders: props.placeholders ? props.placeholders : null,
      technicians: []
    };
  }

  editorDragover(e) {}

  editorDragenter() {}

  editorDragleave() {}

  editorDrop(e) {}

  componentDidMount() {
    const currentUser = this.context?.user || {};
    const userRole = currentUser?.role?.roleFeatureList || [];
    const isTechAuthorised = isAuthorised(userRole, 'employees.view');
    if (isTechAuthorised) {
      AccountClient.query({
        query: GET_ALL_TECHS_NEW,
        variables: {
          input: {
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              }
            }
          }
        }
      }).then((res) => {
        if (res?.data?.getTechnicianList?.userList) {
          const allTechs = res.data.getTechnicianList.userList.map((tech) => ({
            ...tech,
            id: tech.userId,
            value: tech.name
          }));
          this.setState({ technicians: allTechs });
        }
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.placeholders !== state.placeholders) {
      return {
        ...state,
        placeholders: props.placeholders
      };
    }
    return null;
  }

  handleDrop = (idx, item) => {};

  handleDragOver = (idx, item) => {};

  setEditorReference = (ref) => {
    this.editorReferece = ref;
  };

  render() {
    const { placeholders, technicians } = this.state;
    const {
      editorRef,
      handleFileAttachments,
      handleAttachmentsDeletion,
      template,
      updateTemplate,
      placeholder,
      module,
      attachmentModule,
      details,
      allowMentions,
      disabled,
      isUploading,
      customHeaderValue,
      focusEditor = false,
      scrollIntoView,
      hideToolbar,
      allowPlaceholdersUpdate,
      singleAttachment,
      acceptAllType,
      showInlineImage = true,
      translateInnerHtml = true
    } = this.props;

    return (
      <div superid="emailEditor" className="full-height full-width">
        <RTEditor
          editorRef={editorRef}
          focusEditor={focusEditor}
          placeholder={placeholder}
          fields={placeholders}
          userMentions={allowMentions ? technicians : null}
          handleFileAttachments={handleFileAttachments}
          handleAttachmentsDeletion={handleAttachmentsDeletion}
          module={module || 'TICKET_NOTIFICATION_TEMPLATE'}
          attachmentModule={attachmentModule}
          details={details}
          template={template}
          updateTemplate={updateTemplate}
          disabled={disabled}
          isUploading={isUploading}
          customHeaderValue={customHeaderValue}
          groupedIcon
          scrollIntoView={scrollIntoView}
          hideToolbar={hideToolbar}
          allowPlaceholdersUpdate={allowPlaceholdersUpdate}
          singleAttachment={singleAttachment}
          acceptAllType={acceptAllType}
          customToolbarComponent={this.props?.customToolbarComponent}
          showInlineImage={showInlineImage}
          translateInnerHtml={translateInnerHtml}
        />
      </div>
    );
  }
}
export default injectIntl(EmailEditor);
